<h1 *ngIf="!user" class="px-2 mx-auto">Loading...</h1>
<section *ngIf="user" class="flex flex-col justify-center">
  <h1
    class="px-2 m-2 mb-2 text-center bg-gray-800 border border-gray-800 border-solid"
  >
    {{ user.name }} ({{ user.id }})
  </h1>

  <h2
    *ngIf="validationError"
    class="px-2 m-2 text-center bg-gray-800 border-4 border-red-800 border-solid"
  >
    {{ validationError }}
  </h2>

  <form
    [formGroup]="userForm"
    (ngSubmit)="onSubmit()"
    class="grid grid-cols-3 gap-1 p-1 mx-auto mt-4 border-4 border-gray-700 border-solid"
  >
    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">Id</div>
    <div class="col-span-2 px-2 text-right border border-gray-800 border-solid">
      {{ user.id }}
    </div>

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
      Aktualisiert
    </div>
    <div class="col-span-2 px-2 text-right border border-gray-800 border-solid">
      {{ user.updatedAt | date: "dd.MM.yyyy HH:mm" }}
    </div>

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
      Erstellt
    </div>
    <div class="col-span-2 px-2 text-right border border-gray-800 border-solid">
      {{ user.createdAt | date: "dd.MM.yyyy HH:mm" }}
    </div>

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">Name</div>
    <input
      id="name"
      type="text"
      placeholder="Name"
      formControlName="name"
      class="w-full col-span-2 px-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
    />

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
      Passwort
    </div>
    <input
      id="password"
      type="password"
      placeholder="Passwort"
      formControlName="password"
      class="w-full col-span-2 px-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
    />

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
      Passwort wiederholung
    </div>
    <input
      id="passwordConfirmation"
      type="password"
      placeholder="Passwort wiederholung"
      formControlName="password2"
      class="w-full col-span-2 px-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
    />

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
      Spieler-Id
    </div>
    <input
      id="playerId"
      type="number"
      placeholder="Spieler-Id"
      formControlName="playerId"
      class="w-full col-span-2 px-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
    />

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
      Rollen
    </div>

    <ng-select
      class="w-full col-span-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
      [items]="roles"
      bindLabel="name"
      bindValue="id"
      [multiple]="true"
      clearAllText="Clear"
      formControlName="selectedRoles"
    >
    </ng-select>

    <div class="px-2 bg-gray-800 border border-gray-800 border-solid">
      Notizen
    </div>
    <textarea
      id="notes"
      placeholder="Keine Notiz gesetzt"
      formControlName="notes"
      class="w-full col-span-2 px-2 text-left text-black bg-gray-700 border-2 border-gray-500 border-solid focus:border-orange-300"
    ></textarea>
    <div></div>
    <div class="col-span-2 flex justify-between mt-4">
      <div>
        <button
          type="submit"
          [disabled]="!userForm.valid"
          class="w-32 py-1 bg-gray-800 border border-gray-500 border-solid rounded-md disabled:opacity-50 hover:border-orange-300 hover:text-orange-300"
        >
          Speichern
        </button>
        <button
          type="button"
          (click)="onReset()"
          class="w-32 py-1 ml-2 bg-gray-800 border border-gray-500 border-solid rounded-md hover:border-orange-300 hover:text-orange-300"
        >
          Abbrechen
        </button>
      </div>
      <button
        type="button"
        (click)="onDelete()"
        class="w-32 py-1 bg-red-900 border border-red-500 border-solid rounded-md hover:bg-red-800 hover:text-white"
      >
        Löschen
      </button>
    </div>
  </form>
</section>
